<template>
  <v-container>
    <v-row>
      <v-col cols="12" xl="6" lg="6" md="6" class="justify-start">
        <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" label="Buscar..." clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" class="d-flex justify-end">
        <v-btn rounded color="primary" @click="updateDelivery(null)">
          <v-icon> mdi-plus </v-icon>
          Agregar entrega
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table fixed-header height="300px" :headers="headers" :items="orderDeliveries" :items-per-page="10"
      no-data-text="No hay entregas" loading-text="Cargando entregas..." :page.sync="page" hide-default-footer
      :loading="fetchingData" show-expand :single-expand="true" :expanded.sync="expanded" item-key="_id">
      <template #[`item.status`]="{ item }">
        <span v-if="item.status == 'STARTED'"> Nuevo </span>
        <span v-else-if="item.status == 'PAUSE'"> Pausada </span>
        <span v-else-if="item.status == 'FINISHED'"> Finalizada </span>
        <span v-else-if="item.status == 'DELIVERED'"> Entregada </span>
        <span v-else-if="item.status == 'CANCELED'"> Cancelada </span>
        <span v-else> No reconocido </span>
      </template>
      <template #[`item.serial`]="{ item }">
        <span>{{ item.serial }}</span>
        <v-btn color="yellow" icon v-if="item.isUrgent">
          <v-icon>mdi-star</v-icon>
        </v-btn>
      </template>
      <template #[`item.deliveryProductionDate`]="{ item }">
        <span v-if="item.deliveryProductionDate">
          {{ item.deliveryProductionDate }}
        </span>
        <span v-else> --/--/-- </span>
      </template>

      <template #[`item._id`]="{ item }">
        <v-menu :rounded="true" offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn class="white--text ma-5" v-bind="attrs" v-on="on" text fab x-small>
              <v-icon color="black"> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="updateDelivery(item)">
              <v-list-item-title> Actualizar </v-list-item-title>
            </v-list-item>
            <v-list-item @click="showCancelOPModal(item)">
              <v-list-item-title> Cancelar </v-list-item-title>
            </v-list-item>

            <v-list-item @click="showPauseOPModal(item)">
              <v-list-item-title> Pausar </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openCopyModal(item)">
              <v-list-item-title> Copiar </v-list-item-title>
            </v-list-item>
            <v-list-item @click="addDate(item)">
              <v-list-item-title> Agregar fecha producción </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template #expanded-item="{ headers, item }">
        <td class="px-0 py-2" :colspan="headers.length">
          <template>
            <v-data-table :headers="headersChild" :items="item.orderProducts" item-key="_id"
              no-data-text="No hay productos" hide-default-footer elevation="0">
              <template #[`item.type`]="{ item }">
                <span v-if="item.type">
                  {{ item.type.name }}
                </span>
                <span v-else>-</span>
              </template>
              <template #[`item.line`]="{ item }">
                <span v-if="item.moType && item.line">
                  <div v-if="item.moType == 'bacteria'">
                    <div v-if="item.name == 'Streptomyces griseoviridis'">
                      AS
                    </div>
                    <div v-else>B{{ item.line }}</div>
                  </div>
                  <div v-if="item.moType == 'fungi'">H{{ item.line }}</div>
                </span>
                <span v-else>
                  <span v-if="item.line">
                    {{ item.line }}
                  </span>
                  <span v-else>-</span>
                </span>
              </template>
              <template #[`item.presentation`]="{ item }">
                <span v-if="item.productType != 'KIT'">{{
                  item.presentation.name
                  }}</span>
                <span v-else>-</span>
              </template>
              <template #[`item.status`]="{ item }">
                <span v-if="item.status == 'NOT_SUPPLY'"> No surtida </span>
                <span v-else-if="item.status == 'SUPPLIED'">
                  <v-icon color="primary"> mdi-check-decagram </v-icon>
                  Surtida
                </span>
                <span v-else-if="item.status == 'ASSIGNED'">
                  <v-icon color="info"> mdi-archive-clock-outline </v-icon>
                  Asignado
                </span>
                <span v-else-if="item.status == 'PAUSE'">
                  <v-icon color="info"> mdi-pause-circle </v-icon>
                  Pausado
                </span>
                <span v-else-if="item.status == 'CANCELED'">
                  <v-icon color="error"> mdi-cancel </v-icon>
                  Cancelado
                </span>
                <span v-else> No reconocido </span>
              </template>
              <template #[`item.createdAt`]="{ item }">
                <span>{{ dateFormat(item.createdAt) }}</span>
              </template>
            </v-data-table>
          </template>
        </td>
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="numPages" total-visible="10" color="primary"></v-pagination>
    <UpdateDelivery v-model="showUpdateDelivery" @update="updateData()" v-if="showUpdateDelivery" />
    <AddDeliveryOP v-model="showAddDeliveryOP" @update="updateData()" v-if="showAddDeliveryOP" />
    <AddDateProductionDelivery v-model="showAddDateProductionDelivery" @update="updateData()"
      v-if="showAddDateProductionDelivery" />
    <CopyDeliveryOPModal v-if="copyOP" v-model="showCopyDeliveryOPModal" :copyOP="copyOP" @update="update"
      :title="`¿Estás seguro que quieres copiar la entrega ${copyOP.serial}?`" />
    <CancelOP v-model="showCancelOP" @confirmation="updateData()"
      :title="`¿Estás seguro que quieres cancelar la entrega ${deliveryToUpdate.serial}?`" v-if="deliveryToUpdate" />
    <PauseOP v-model="showPauseOP" @confirmation="updateData()"
      :title="`¿Estás seguro que quieres pausar la entrega ${deliveryToUpdate.serial}?`" v-if="deliveryToUpdate" />
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import AddDeliveryOP from "@/components/dashboard/production-orders/modals/AddDeliveryOP.vue";
import UpdateDelivery from "@/components/dashboard/production-orders/modals/UpdateDelivery.vue";
import AddDateProductionDelivery from "@/components/dashboard/production-orders/modals/AddDateProductionDelivery.vue";
import CopyDeliveryOPModal from "@/components/dashboard/production-orders/modals/CopyDeliveryOPModal.vue";
import CancelOP from "@/components/dashboard/production-orders/modals/CancelOPModal.vue";
import PauseOP from "@/components/dashboard/production-orders/modals/PauseOPModal.vue";

export default {
  components: {
    AddDeliveryOP,
    UpdateDelivery,
    AddDateProductionDelivery,
    CopyDeliveryOPModal,
    CancelOP,
    PauseOP,
  },
  data: () => ({
    showCancelOP: false,
    showPauseOP: false,
    showAddDateProductionDelivery: false,
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showAddDeliveryOP: false,
    showUpdateDelivery: false,
    showCopyDeliveryOPModal: false,
    client: null,
    saleType: null,
    label: null,
    copyOP: null,
    saleTypes: [
      { name: "R", value: "R" },
      { name: "OP", value: "OP" },
      { name: "P", value: "P" },
      { name: "OR", value: "OR" },
      { name: "I", value: "I" },
      { name: "M", value: "M" },
      { name: "KIT", value: "KIT" },
    ],
    headers: [
      {
        text: "Serial",
        align: "start",
        value: "serial",
        sortable: false,
      },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Fecha de entrega",
        align: "center",
        value: "deliveredDate",
        sortable: false,
      },
      {
        text: "Fecha de entrega producción",
        align: "center",
        value: "deliveryProductionDate",
        sortable: false,
      },
      {
        text: "Acciones",
        align: "center",
        value: "_id",
        sortable: false,
      },
    ],
    headersChild: [
      { text: "Nombre", align: "start", value: "name", sortable: false },
      { text: "Tipo", value: "productType", sortable: false },
      {
        text: "Cantidad",
        align: "center",
        value: "qty",
        sortable: false,
      },
      {
        text: "Linea",
        align: "center",
        value: "line",
        sortable: false,
      },
      {
        text: "Presentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Fecha de creación",
        align: "center",
        value: "createdAt",
        sortable: false,
      },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
    ],
    orderDeliveries: [],
    fetchingData: false,
    page: 1,
    search: null,
    filters: null,
    numPages: 1,
    expanded: [],
  }),
  props: {
    tab: Number,
  },
  computed: {
    ...mapState("order", ["orderToUpdate", "deliveryToUpdate"]),
  },
  async created() {
    await this.loadData()
  },
  methods: {
    ...mapActions("order", ["getDeliverytOrders", "updateOP"]),
    ...mapMutations("order", [
      "SET_DELIVERY_OP_TO_UPDATE",
      "SET_ORDER_TO_UPDATE",
    ]),
    async updateOPRequest() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            client: this.client,
            user: this.user,
            saleType: this.saleType.value,
            label: this.label,
            order: this.orderToUpdate._id,
          };

          let response = await this.updateOP(payload);
          if (response) {
            this.$swal({
              icon: "success",
              title: `OP actualizada`,
              showConfirmButton: false,
              timer: 1000,
            });
            this.$emit("update");
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al actualizar OP`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al actualizar OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getDeliverytOrders({
          page: this.page,
          search: this.search,
          filters: this.filters,
          orderId: this.orderToUpdate._id,
        });

        if (response) {
          if (!response.error) {
            this.orderDeliveries = response.deliveryOrders;
            // this.SET_ORDER_EVENTS(response.orders);
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar ordenes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar ordenes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar ordenes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    updateDelivery(item) {
      console.log("updateDelivery", item);

      this.SET_DELIVERY_OP_TO_UPDATE(item);
      if (item) {
        this.showUpdateDelivery = true;
      } else {
        this.showAddDeliveryOP = true;
      }
    },
    addDate(item) {
      this.SET_DELIVERY_OP_TO_UPDATE(item);
      this.showAddDateProductionDelivery = true;
    },
    async updateData() {
      await this.fetchData();
      this.showAddDeliveryOP = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    openCopyModal(item) {
      this.copyOP = item;
      this.showCopyDeliveryOPModal = true;
    },
    async update() {
      this.copyOP = null;
      this.showCopyDeliveryOPModal = false;
      await this.fetchData();
    },
    async showCancelOPModal(item) {
      this.SET_DELIVERY_OP_TO_UPDATE(item);
      this.showCancelOP = true;
    },
    async showPauseOPModal(item) {
      this.SET_DELIVERY_OP_TO_UPDATE(item);
      this.showPauseOP = true;
    },
    async cancelOP() {
      console.log("CANCEL");
    },
    async pauseOP() {
      console.log("PAUSE");
    },
    async loadData() {
      this.client = this.orderToUpdate.client;
      this.saleType = this.orderToUpdate.saleType;
      this.label = this.orderToUpdate.label;
      await this.fetchData();
    }
  },
  watch: {
    async search() {
      this.page = 1;
      this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
    async tab(value) {
      if (value == 1) {
        await this.loadData()
      }
    }
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
